export default __webpack_public_path__ + "static/media/dropdown-arrow.f2cfcc76.svg";